import React from "react";

import viewIcon from "images/icons/invite/view.svg";

export default function Actions({ row }) {
  const startRenewal = (e, row) => {
    //actions.showEditForm(dispatch, row);
  };

  return (
    <div>
      <a
        target="_blank"
        href={`/enterprises/${row.attributes.enterprise_id}/edit#tab-policy`}
        onClick={(e) => startRenewal(e, row)}
      >
        <img src={viewIcon} />
      </a>
    </div>
  );
}
